import { render, staticRenderFns } from "./SelectDisasterArea.vue?vue&type=template&id=f9ab1bf8&"
import script from "./SelectDisasterArea.vue?vue&type=script&lang=js&"
export * from "./SelectDisasterArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports